import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { UseDataProps } from './types';
import { HOME } from '10.quickConnect.app/routes/paths';

const useData = (): UseDataProps => ({});

export default useData;
